import "./style.scss";
import CloseSvg from "@/src/svg/CloseSvg";
import { Link, useNavigate } from "react-router-dom";
import NavigationArrowSvg from "@/src/svg/NavigationArrowSvg";
import { FC, Fragment, useEffect, useState } from "react";
import { INavigationsData } from "@/src/types/INavigation";
import { navigationConst, navigationDynamicConst } from "@/src/constants/navigation";
import NavigationItem from "./NavigationItem/NavigationItem";
import { Phone } from "@/src/svg/Phone";
import { Mail } from "@/src/svg/Mail";

interface INavigation {
  currentNavigationName?: string;
}

const Navigation: FC<INavigation> = ({ currentNavigationName }) => {
  const navigate = useNavigate();
  const [currentData, setCurrentData] = useState<INavigationsData>(navigationConst);

  useEffect(() => {
    if (currentNavigationName !== "NavigationPage") {
      navigationDynamicConst.forEach((item) => {
        if (item.id === currentNavigationName) {
          setCurrentData(item);
        }
      });
    }
  }, [currentNavigationName]);
  return (
    <div className="navigation">
      <div className="navigation-header">
        <div className="navigation-top">
          <div className="navigation-top-content">
            <Link to={"/"} className="navigation-number">
              <Phone />
              <p>+998 90 006 44 43 | +998 95 794 44 42</p>
            </Link>
            <a href="mailto:info@msmbmalta.com" className="navigation-mail">
              <Mail />
              <p>info@msmbmalta.com</p>
            </a>
          </div>
        </div>
        <div className="navigation-bottom">
          <div className="navigation-back" onClick={() => navigate(-1)}>
            <NavigationArrowSvg />
          </div>
          <div className="navigation-title">
            <p>{currentData.title}</p>
          </div>
          <Link to={"/"} className="navigation-close">
            <CloseSvg />
          </Link>
        </div>
      </div>
      <div className="navigation-items">
        {currentData.data.map((item) => (
          <Fragment key={item.id}>
            <NavigationItem id={item.id} text={item.text} image={item.image} link={item.link as undefined} />
          </Fragment>
        ))}
      </div>
      <div className="navigation-button">
        <Link to={"/apply-online"} className="btn-default reverse">
          Оставить заявку
        </Link>
      </div>
    </div>
  );
};

export default Navigation;
